import axios from "@/widgets/shared/utils/axios-instance";
import {
  isSessionOverlapping,
  isWomenInTechCareerDayI,
  isWomenInTechCareerDayII,
  isWomenInTechSoftSkillFirst,
  isWomenInTechSoftSkillSecond,
  isWomenInTechTechSkills,
} from "@/widgets/shared/utils";

export function state() {
  return {
    ids: [],
    agendaSessionTickets: [],
  };
}

export const mutations = {
  async setTickets(state, agendaSessionTickets) {
    state.agendaSessionTickets = agendaSessionTickets;
  },

  async appendTicket(state, agendaSessionTicket) {
    state.agendaSessionTickets = [...state.agendaSessionTickets, agendaSessionTicket];
  },

  async removeTicket(state, agendaSessionTicketId) {
    const tickets = state.agendaSessionTickets;
    state.agendaSessionTickets = tickets.filter(ticket => ticket.agenda_session_ticket.id !== agendaSessionTicketId);
  },
};

export const actions = {
  async loadUserTickets({ commit, rootState }) {
    // const result = await axios.get(`current_user/tickets`);
    await axios
      .get(`current_user/tickets`)
      .then(result => {
        const agendaSessionTickets = result.data.agenda_session_ticket_reservations.filter(ticket => {
          const isFromCurrentEvent = ticket.event_display_data.id === rootState.eventId;
          const hasSessionTicketData = !!ticket.agenda_session_ticket;
          return isFromCurrentEvent && hasSessionTicketData;
        });
        commit("setTickets", agendaSessionTickets);
      })
      .catch(err => {
        commit("setTickets", []);
      });

    // const agendaSessionTickets = result.data.agenda_session_ticket_reservations.filter(
    //   ticket => ticket.event_display_data.id === rootState.eventId
    // );
    // commit("setTickets", agendaSessionTickets);
  },

  async buyTicket({ commit, rootState, dispatch, rootGetters }, { agendaSession, ticketId }) {
    const mySessions = rootGetters["schedule/allSessions"];
    if (rootState.eventId === 1234) {
      if (!mySessions) {
        throw new Error("Content not loaded, please try again.");
      } else {
        isSessionOverlapping(agendaSession, mySessions);
      }
    }

    const result = await axios.post(
      `events/${rootState.eventId}/components/${agendaSession.event_component_id}/agenda_sessions/${agendaSession.id}/buy_ticket/${ticketId}`
    );

    const agendaSessionTicket = result.data;
    commit("appendTicket", agendaSessionTicket);
    commit("schedule/addSession", agendaSession, { root: true });
    commit("sessions/decrementFreePlacesForSession", agendaSession.id, { root: true });
    dispatch(
      "agendaSessionAttendees/loadAttendeesFromSession",
      {
        agendaSessionId: agendaSession.id,
        force: true,
      },
      { root: true }
    );
    if (isWomenInTechSoftSkillFirst(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message:
            "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce! Pamiętaj aby w drugiej połowie dnia wybrać Targi Kariery II ;)",
        },
        { root: true }
      );
    } else if (isWomenInTechSoftSkillSecond(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message:
            "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce! Pamiętaj aby w pierwszej połowie dnia wybrać Targi Kariery I ;)",
        },
        { root: true }
      );
    } else if (isWomenInTechTechSkills(agendaSession)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message: "Gotowe! Zarejestrowałaś się na te warsztaty, do zobaczenia wkrótce!",
        },
        { root: true }
      );
    } else if (isWomenInTechCareerDayI(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message:
            "Gotowe! Zarejestrowałaś się na Targi Kariery I, do zobaczenia wkrótce! Pamiętaj aby w drugiej połowie dnia wybrać warsztaty ;)",
        },
        { root: true }
      );
    } else if (isWomenInTechCareerDayII(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message:
            "Gotowe! Zarejestrowałaś się na Targi Kariery II, do zobaczenia wkrótce! Pamiętaj aby w pierwszej połowie dnia wybrać warsztaty ;)",
        },
        { root: true }
      );
    }
  },

  async returnTicket({ commit, rootState, dispatch }, { agendaSession, ticketId }) {
    const result = await axios.delete(
      `events/${rootState.eventId}/components/${agendaSession.event_component_id}/agenda_sessions/${agendaSession.id}/return_ticket/${ticketId}`
    );

    commit("removeTicket", ticketId);
    commit("schedule/removeSession", agendaSession.id, { root: true });
    commit("sessions/incrementFreePlacesForSession", agendaSession.id, { root: true });
    dispatch(
      "agendaSessionAttendees/loadAttendeesFromSession",
      {
        agendaSessionId: agendaSession.id,
        force: true,
      },
      { root: true }
    );

    if (
      isWomenInTechSoftSkillFirst(agendaSession.id) ||
      isWomenInTechSoftSkillSecond(agendaSession.id) ||
      isWomenInTechTechSkills(agendaSession)
    ) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message: "Zostałaś wyrejestrowana z tych warsztatów. Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    } else if (isWomenInTechCareerDayI(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message: "Zostałaś wyrejestrowana z Targów Kariery I Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    } else if (isWomenInTechCareerDayII(agendaSession.id)) {
      commit(
        "lpNotifications/showSuccessNotification",
        {
          title: agendaSession.name,
          message: "Zostałaś wyrejestrowana z Targów Kariery II Jeśli zmienisz zdanie, śpiesz się, potem może nie być miejsc! :)",
        },
        { root: true }
      );
    }
  },
};

export const getters = {
  hasTicketForSession: state => agendaSessionId =>
    state.agendaSessionTickets &&
    state.agendaSessionTickets.filter(ticket => ticket.agenda_session_display_data.id === agendaSessionId).length > 0,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
